import type { IconSvgObject } from './types';

const Invoice01Icon: IconSvgObject = [
  ["path", { d: "M11.5 11H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 7H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 21.5V4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4V21.5L8 19.5L12 22L16 19.5L20 21.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Invoice01Icon;
